<div style="">
  <mat-dialog-content class="mat-typography TC_container" id="teamsAddModal">
    <div class="section_login">
  
      <button style="outline: none;" class="close-button forgetPass" (click)="CloseModal()" [mat-dialog-close]="true"
        id="closeBtn">
        <img src="../../../assets/icons/x-button.svg">
      </button>
  
      <form action="" [formGroup]="playerForm">
        <div class="row">
  
  
          <div class="">
            <p class="authHeadText">Add Player</p>
            <div style="">
              <div>
                <label class="fw-bold">Search Player By Name</label>
                <div class="form-group mt-3">
                  <mat-form-field class="w-100 example-full-width" appearance="fill" id="textmaster">
                    <input type="text" matInput [matAutocomplete]="auto" formControlName="playerName"
                      placeholder="Search Player">
                    <button class="btncross" *ngIf="selectedPlayer" matSuffix mat-icon-button aria-label="Clear"
                      (click)="clearPlayer()">
                      <i class="fa-regular fa-circle-xmark btncross fa-2x"></i>
                    </button>
                    <mat-autocomplete [panelWidth]="400" #auto="matAutocomplete" (optionSelected)="onSelectedPlayer($event)"
                      [displayWith]="displayWithPlayer" class="players-list">
                      <mat-option *ngIf="isLoading" class="is-loading">Loading...</mat-option>
                      <ng-container *ngIf="!isLoading">
                        <mat-option *ngFor="let single of playersList" [value]="single">
                          <span><b>{{single?.firstName}} {{single?.lastName}}</b>
                          </span>
                        </mat-option>
                      </ng-container>
                    </mat-autocomplete>
                  </mat-form-field>
                </div>
    
                <div class="col-md-12">
                  <button mat-raised-button color="warn" *ngIf="this.data.userType.access == 'add'"
                    [mat-dialog-close]="true" (click)="addTeamPlayer()"
                    [disabled]="!selectedValuePlayer || playerForm.invalid" style="width: 100% !important;" class="authSignIn">Add
                    Player</button>
                </div>
              </div>
            </div>
          </div>
        </div>
  
      </form>
    </div>
  </mat-dialog-content>
</div>